import React from "react";

import { useLocation } from "react-router-dom";

import landingPreviewHeaderBG from "images/landing-page/landing-preview-header-bg.png";

import { useIsTablet } from "app/hooks";
import { isIRC, isMicrosoft, isProgressive, isSynopsys, isTarget } from "app/utils";

import ShareLinkComponent from "components/common/ShareLinkComponent";

const DEFAULT_COLOR = "#79b17d";

interface ProgressiveHeaderImageProps {
  landingPage: any;
  isTablet: boolean;
}

const ProgressiveHeaderImage: React.FC<ProgressiveHeaderImageProps> = (
  { landingPage, isTablet }
) => {
  if (!landingPage) return <div className="Empty-Header-Image" />;

  if (landingPage?.name?.replace(/\s+/g, "-")?.toLowerCase() === "progressive-internship-program") {
    return (
      <img
        className="Png-Header-Image"
        src={isTablet ? "https://culturehq-assets.s3.us-west-2.amazonaws.com/culture-pages/progressive/Mobile-Header-College.png " : "https://culturehq-assets.s3.us-west-2.amazonaws.com/culture-pages/progressive/Desktop-Header-College.png"}
        alt=""
      />
    );
  }

  return (
    <img
      className="Png-Header-Image"
      src={isTablet ? "https://culturehq-assets.s3.us-west-2.amazonaws.com/culture-pages/progressive/Mobile-Header.png" : "https://culturehq-assets.s3.us-west-2.amazonaws.com/culture-pages/progressive/Desktop-Header.png"}
      alt=""
    />
  );
};

interface HeaderImageProps {
  landingPage: any;
  orgName: string;
}

const HeaderImage: React.FC<HeaderImageProps> = ({ landingPage, orgName }) => {
  const { search } = useLocation();
  const isTablet = useIsTablet();

  const PreviewHeaderTextStyle = isMicrosoft(orgName) || isSynopsys(orgName)
    || isProgressive(orgName) ? {}
    : { backgroundImage: `linear-gradient(120deg, ${landingPage?.primaryColor || DEFAULT_COLOR} 0%, ${landingPage?.primaryColor || DEFAULT_COLOR}38 100%)` };

  const getHeaderText = () => {
    if (isIRC(landingPage?.organization?.name)) {
      return <>Where your mission meets<span className="Preview-Header__Text--underlined">purpose and meaning.</span></>;
    }
    return landingPage?.headerText;
  };

  const getHeaderBackgroundImage = () => (
    landingPage?.headerImageUrl ? `url(${landingPage?.headerImageUrl})` : `url(${landingPreviewHeaderBG})`
  );

  if (isTarget(orgName)) {
    return (
      <div style={{ position: "relative" }}>
        <img
          className="Png-Header-Image"
          src={isTablet ? "https://culturehq-assets.s3.us-west-2.amazonaws.com/culture-pages/target/Mobile-Header.jpg" : "https://culturehq-assets.s3.us-west-2.amazonaws.com/culture-pages/target/Desktop-Header.png"}
          alt=""
        />
        <div className="Preview-Header__Overlay">
          <h1 className="Preview-Header__Text hidden-xs" style={PreviewHeaderTextStyle}>
            {landingPage?.headerText}
          </h1>
        </div>
        {landingPage?.organization && (
          <div className="Png-ShareLink-Container">
            <ShareLinkComponent
              link={`https://${orgName.replace(/\s+/g, "-").toLowerCase()}.culturehq.com${search || ""}`}
              organizationId={landingPage.organization.id}
              orgName={orgName}
            />
          </div>
        )}
      </div>
    );
  }

  if (isProgressive(orgName)) {
    return (
      <div style={{ position: "relative" }}>
        <ProgressiveHeaderImage
          landingPage={landingPage}
          isTablet={isTablet}
        />
        <div className="Preview-Header__Overlay">
          {!isTablet && (
            <h1 className="Preview-Header__Text hidden-sm" style={PreviewHeaderTextStyle}>
              {landingPage?.headerText}
            </h1>
          )}
        </div>
        {landingPage?.organization && (
          <div className="Png-ShareLink-Container">
            <ShareLinkComponent
              link={`https://${orgName.replace(/\s+/g, "-").toLowerCase()}.culturehq.com${search || ""}`}
              organizationId={landingPage.organization.id}
              orgName={orgName}
            />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="Preview-Header__Image" style={landingPage?.headerText ? { backgroundImage: getHeaderBackgroundImage() } : { backgroundColor: "#CACACA" }}>
      <div className="Preview-Header__Overlay">
        <h1 className="Preview-Header__Text hidden-xs" style={PreviewHeaderTextStyle}>
          {getHeaderText()}
        </h1>
      </div>
      {landingPage?.organization && (
        <ShareLinkComponent
          link={`https://${orgName.replace(/\s+/g, "-").toLowerCase()}.culturehq.com${search || ""}`}
          organizationId={landingPage.organization.id}
          orgName={orgName}
        />
      )}
    </div>
  );
};

export default HeaderImage;
